module.exports = __webpack_public_path__ + "img/冈田侑大.fa6a055e.png";